// PaymentScreen.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { useStyle } from "../context/StyleContext";

const PaymentScreen = () => {
  const navigate = useNavigate();
  const [paymentStatus, setPaymentStatus] = useState(false);
  const [userIP, setUserIP] = useState(null);
  const styles = useStyle();

  useEffect(() => {
    const token = localStorage.getItem("paymentToken");
    if (token) {
      navigate("/photo-capture");
    }
  }, [navigate]);

  useEffect(() => {
    const fetchIP = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setUserIP(response.data.ip);
      } catch (error) {
        console.error("Failed to fetch IP address:", error);
      }
    };

    fetchIP();
  }, []);

  const loadRazorpay = () => {
    return new Promise((resolve) => {
      if (
        document.querySelector(
          `script[src="https://checkout.razorpay.com/v1/checkout.js"]`
        )
      ) {
        console.log("reached first");
        resolve(true);
        return;
      }
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      console.log("script added");
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  const handlePayment = async () => {
    try {
      const res = await loadRazorpay();

      console.log("loaded razorpay");

      if (!res) {
        alert("Razorpay SDK failed to load. Are you online?");
        return;
      }
      console.log(`${process.env.REACT_APP_API_URL}/api/payment/create-order`);
      const result = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/payment/create-order`,
        {
          amount: 149, // amount in currency subunits (e.g., paise for INR)
          currency: "INR",
          receipt: "receipt#1",
          notes: {
            address: styles.restaurantName,
            userIP: userIP,
          },
        }
      );

      if (!result.data) {
        alert("Server error. Are you online?");
        return;
      }

      const { amount, id: order_id, currency } = result.data;

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID, // Enter the Key ID generated from the Dashboard
        amount: amount.toString(),
        currency: currency,
        name: "Memories Photobooth",
        description: "Transaction for taking the photos",
        order_id: order_id,
        handler: async function (response) {
          try {
            const data = {
              orderCreationId: order_id,
              razorpayPaymentId: response.razorpay_payment_id,
              razorpayOrderId: response.razorpay_order_id,
              razorpaySignature: response.razorpay_signature,
            };

            console.log(data);
            const result = await axios.post(
              `${process.env.REACT_APP_API_URL}/api/payment/verify`,
              data
            );

            if (result.data.success) {
              localStorage.setItem("paymentToken", "your-unique-token");
              setPaymentStatus(true);
              navigate("/photo-capture");
            } else {
              alert("Payment verification failed. Please try again.");
            }
          } catch (error) {
            console.error("Payment verification error:", error);
            alert("Payment verification failed. Please try again.");
          }
        },
        prefill: {
          name: "Memories Photobooth",
          email: "memoriesphotosbooth@gmail.com",
          contact: "9686145731 ", // You can put any dummy number here
        },
        notes: {
          address: localStorage.getItem("photobooth_boothName"),
          userIP: userIP,
        },
        theme: {
          color: "#F58B54",
        },
        modal: {
          backdropClose: false, // Updated property name to match Razorpay docs.
          ondismiss: function () {
            console.log("Dismissed payment modal!");
          },
          escape: false, // Disallow closing the modal when pressing escape.
        },
        // Removed unsupported "method" property to fix the Razorpay error page.
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    } catch (error) {
      console.error("Payment error:", error.message);
      alert("Something went wrong. Please try again.");
    }
  };

  useEffect(() => {
    if (paymentStatus) {
      navigate("/photo-capture");
    }
  }, [paymentStatus, navigate]);

  const heading = "Payment Screen";
  const letters = heading.split("");

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden">
      <img
        src={styles.restaurantLogo}
        width={"600px"}
        alt="Background"
        className="mix-blend-darken absolute top-[5%] left-1/2 transform -translate-x-1/2 w-l h-l object-cover z-0"
      />
      <div
        className="relative text-center px-5 mx-16 py-24 mt-36 rounded-3xl z-50 shadow-lg"
        style={{
          backgroundColor: styles.backgroundColor,
          color: styles.textColor,
        }}
      >
        <div
          className="text-4xl sm:text-8xl font-bold mb-16 flex justify-center"
          style={{
            color: styles.textColor,
            fontFamily: styles.fontFamily,
            fontWeight: "bold",
          }}
        >
          {letters.map((letter, index) => (
            <motion.span
              key={index}
              className="inline-block"
              initial={{ y: -50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
            >
              {letter === " " ? "\u00A0" : letter}
            </motion.span>
          ))}
        </div>
        <p
          className="text-4xl mb-16"
          style={{
            color: styles.textColor,
            fontFamily: styles.fontFamily,
            fontWeight: "bold",
          }}
        >
          Please complete your payment to start the photo session.
        </p>
        <motion.button
          className="px-6 py-3 sm:px-8 sm:py-4 text-3xl bg-indigo-600 font-semibold rounded-lg shadow-lg hover:shadow-xl transform hover:scale-110 transition duration-300 ease-in-out"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={handlePayment}
          style={{
            backgroundColor: styles.buttonColor,
            fontFamily: styles.fontFamily,
            color: styles.textColor,
          }}
        >
          <span className="relative text-5xl p-5">Pay using RAZORPAY</span>
          <div className=" my-2">
            <span className="text-3xl">Total amount of ₹149 </span>
          </div>
        </motion.button>
        {paymentStatus && (
          <p
            className="mt-4 animate-pulse"
            style={{ color: styles.buttonColor }}
          >
            Payment successful! Redirecting...
          </p>
        )}
      </div>
      <div
        className=" h-[10vh] font-bold text-xl mt-10 mx-[10%] p-4 rounded-lg absolute bottom-16 left-0 right-0"
        style={{
          color: styles.textColor,
        }}
      >
        <p
          style={{
            fontFamily: styles.fontFamily,
            color: styles.textColor,
            textAlign: "center",
          }}
        >
          <span
            style={{
              fontFamily: styles.fontFamily,
              fontWeight: "900",
            }}
          >
            Press Pay to go to next screen
          </span>
        </p>
        <p
          style={{
            fontFamily: styles.fontFamily,
            color: styles.textColor,
            textAlign: "center",
          }}
        >
          <span
            style={{
              fontFamily: styles.fontFamily,
              fontWeight: "900",
            }}
          >
            Terms and conditions:
          </span>
          we are not liable for any loss or personal injuries resulting from use
          of our Photo Booth services
          <br /> Click on "i" icon on top right of screen to view all the
          conditions
        </p>
      </div>
    </div>
  );
};

export default PaymentScreen;
